module.exports = ELEMENT;


//////////////////
// WEBPACK FOOTER
// external "ELEMENT"
// module id = 59
// module chunks = 2